import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import SearchProducts from "./SearchProducts";
import StoreLocation from "./StoreLocation";
import Wishlist from "./Wishlist";
import ShoppingCart from "./ShoppingCart";
import MyAccount from "./MyAccount";
import MobileSidebar from "./MobileSidebar";
import Coupon from "../../../assets/icons/coupon.png";

import "./main-header.scss";
import CouponDescription from 'components/CouponCardTheme2/CouponDescription';
import { getLocalStorageValue , handleSignOut } from 'config/helper';
import { useConfigHeader } from 'hooks/useConfig';
import ProductDescriptionModal from 'components/ProductDescriptionModal';

const MainHeader = () => {
  const [mobileSidebar, setMobileSidebar] = useState(false);
  
  const headerSectionData = useSelector(
    ({ common }) => common.commonDetailsData.header_section
  );
  const { allowCoupons, allowGrocery, allowCatering } = useConfigHeader();

  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const { couponDescriptionModalVisible } = useSelector(({ cartCoupon }) => cartCoupon);

  const { has_access_home_page } = useSelector(({ common }) => {
    const { ecom_section, header_section } = common.commonDetailsData;
    return {
      allow_ecommerce: ecom_section?.allow_ecommerce,
      has_access_home_page: header_section?.has_access_home_page,
    };
  });
  const {cateringDepartmentTree} = useSelector(s => s.cateringAndMeal)

  let logoClickUrl
  if (has_access_home_page === "2") {
    const {slug} = cateringDepartmentTree?.[0] ?? {}
    if (slug) {
      logoClickUrl = `/catering-meal/${slug}`
    }
  }

  return (
    <>
      <div className="main-header">
        <ProductDescriptionModal />
        <ProxyShoppingBanner />  
        <div className="container">
          <div className="grid">
            <div className="grid-items mobile-bar-icon">
              <div
                className="mobile-menu"
                onClick={() => setMobileSidebar(!mobileSidebar)}
              >
                <i className="fa-solid fa-bars"></i>
              </div>
            </div>
            <div className="location-mini-wrap">
                  <StoreLocation />
            </div>
            <div className="grid-items mobile-logo">
              <SearchProducts />
              <div className="stickey-logo">
                {headerSectionData && headerSectionData.rsa_client_logo ? (
                  <NavLink to={logoClickUrl || "/"}>
                    <img
                      src={headerSectionData.rsa_client_logo}
                      alt={headerSectionData.image_alt_text}
                    />
                  </NavLink>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="grid-items mobile-location">
              <div className="mobile-store-location">
                <StoreLocation />
              </div>
              <div className="main-header-middle-grid grid-location">
                <div className="main-header-middle-grid-items">
                  <StoreLocation />
                </div>
                <div className="main-header-middle-grid-items grid-search">
                  <SearchProducts />
                </div>
              </div>
            </div>
            <div className={"grid-items-flex-end grid-items"}>
              <div className="header-shop-btn">
                <a href="/departments">Shop</a>
              </div>
              {isUserLoggedIn && allowCoupons && (
                <>
                  <NavLink className="add-to-list-items" to="/list-items">
                    <Wishlist />
                  </NavLink>
                  <div className="coupon-icon-wrapper">
                    <Link to="/coupon-view-cart" className="coupon-icon">
                      <img src={Coupon} alt="coupon" />
                    </Link>

                    <span className="form-control-validation-Coupon">
                      Clipped Coupon
                    </span>
                  </div>
                </>
              )}
              {isUserLoggedIn ? (
                <>
                  <MyAccount />
                  {allowGrocery || allowCatering ? <ShoppingCart /> : null}
                </>
              ) : (
                ""
              )}
              {!isUserLoggedIn ? (
                <div className="auth-links">
                  <ul>
                    <NavLink to="/signup">
                      <li>Sign Up</li>
                    </NavLink>
                    <NavLink to="/login">
                      <li>Sign In</li>
                    </NavLink>
                  </ul>
                </div>
              ) : (
                ""
              )}
              <div className="mobile-auth-links">
                {!isUserLoggedIn ? (
                  <ul>
                    <NavLink to="/login">
                      <i
                        className="fa-regular fa-circle-user"
                        aria-hidden="true"
                      ></i>
                    </NavLink>
                  </ul>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {couponDescriptionModalVisible && (
        <>
            <CouponDescription />
         </>
      )}
      <MobileSidebar
        isMobileSidebar={mobileSidebar}
        onClose={() => setMobileSidebar(false)}
      />
    </>
  );
};

const ProxyShoppingBanner = () => {
  const proxyShopping = getLocalStorageValue("proxy-shopping") === "1";
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);

  if (!isUserLoggedIn || !proxyShopping) {
    return null
  }

  return (
    <div className="proxy-shopping-banner">
      <div className="offer-tag-wrap">
      <div className="container">
      <div className="offer-tag">
        <p> 
           <div className="icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="-3 -4 24 24"
          >
            <path
              fill="currentColor"
              d="M7 16a2 2 0 1 1 0-4a2 2 0 0 1 0 4m7 0a2 2 0 1 1 0-4a2 2 0 0 1 0 4M.962 1.923A.962.962 0 0 1 .962 0h1.151c.902 0 1.682.626 1.878 1.506l1.253 5.642c.196.88.976 1.506 1.878 1.506h7.512l1.442-5.77H6.731a.962.962 0 0 1 0-1.922h9.345a1.923 1.923 0 0 1 1.866 2.39L16.5 9.12a1.92 1.92 0 0 1-1.866 1.457H7.122a3.846 3.846 0 0 1-3.755-3.012L2.113 1.923z"
            />
          </svg>
        </div>You are shopping on behalf of a customer!</p>
        <Link to="/" className="sign-out-link" onClick={handleSignOut}>Sign out</Link>
        </div>
      </div>
      </div>
    </div>
  )
}

export default MainHeader;
